import "../styles/live.css";

const Live = () => {
  return (
    <>
      <h2>Live</h2>
      <hr />

      <div className="Live">
        <h3>2026</h3>

        <div className="container">
          <div className="date">oct 25 |</div>
          <div className="item">
            <p>
              <a href="https://www.medborgarhuset.se/event/utgivningsfest-karneval-och-frageformular" target="_blank">
                <span className="event"><i>Karneval</i> & <i>Frågeformulär</i> release</span>
                <br />
                <span className="venue">Hägerstensåsens medborgarhus (Stockholm, SE)</span>
              </a>
            </p>
          </div>
        </div>

        <div className="container">
          <div className="date">sep 21 |</div>
          <div className="item">
            <p>
              <a href="https://www.facebook.com/events/2499058523902006/?acontext=%7B%22event_action_history%22%3A%5B%7B%22mechanism%22%3A%22attachment%22%2C%22surface%22%3A%22newsfeed%22%7D%5D%2C%22ref_notif_type%22%3Anull%7D" target="_blank">
                <span className="event">Solo set &ndash; live electronics</span>
                <br />
                <span className="venue">Music Innovation Studies Centre &ndash; LMTA (Vilnius, LT)</span>
              </a>
            </p>
          </div>
        </div>

        <div className="container">
          <div className="date">aug 26 |</div>
          <div className="item">
            <p>
              <a href="https://fb.me/e/29imuIvtVf" target="_blank">
                <span className="event">Site-specific sound installation <i>Other Room</i></span>
                <br />
                <span className="venue">Sound Art Lab (Struer, DK)</span>
              </a>
            </p>
          </div>
        </div>

        <div className="container">
          <div className="date">jul 24 |</div>
          <div className="item">
            <p>
              <a href="https://klexoslab.es/" target="_blank">
                <span className="event">KlexosLab 2026 w/ Elisa García (ob.)</span>
                <br />
                <span className="venue">Centro Cultural San Francisco (Plasencia, ES)</span>
              </a>
            </p>
          </div>
        </div>

        <div className="container">
          <div className="date">jul 5 |</div>
          <div className="item">
            <p>
              <a href="https://www.collisionpointsfestival.com/calendar-2" target="_blank">
                <span className="event">Collision Points Festival</span>
                <br />
                <span className="venue">Folkets hus (Ankarsrum, SE)</span>
              </a>
            </p>
          </div>
        </div>

        <div className="container">
          <div className="date">feb 1 |</div>
          <div className="item">
            <p>
              <a href="https://billetto.se/e/au-rum-ii-biljetter-1803363" target="_blank">
                <span className="event">au:rum II</span>
                <br />
                <span className="venue">S:t Sigfrids kyrka (Stockholm, SE)</span>
              </a>
            </p>
          </div>
        </div>

        <h3>2025</h3>

        <div className="container">
          <div className="date">oct 31 |</div>
          <div className="item">
            <p>
              <a href="https://fylkingen.se/en/events/dania-shihab-wilma-hulten-hara-alonso#title" target="_blank">
                <span className="event">Solo set &ndash; live electronics</span>
                <br />
                <span className="venue">Fylkingen (Stockholm, SE)</span>
              </a>
            </p>
          </div>

          <div className="date">jul 26 |</div>
          <div className="item">
            <p>
              <a href="https://www.instagram.com/p/DL8DcKBMS5D/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" target="_blank">
                <span className="event">Laikatonal #1 release</span>
              </a>
            </p>
          </div>
        </div>

        <h3>2024</h3>

        <div className="container">
          <div className="date">may 17 |</div>
          <div className="item">
            <p>
              <a href="https://billetto.se/e/examenskonsert-this-time-it-is-personal-biljetter-992311?vs=0189c81a-4943-4a16-ba8b-dbe3" target="_blank">
                <span className="event">Exam concert: This time it is personal</span>
                <br />
                <span className="venue">Reaktorhallen, KTH (Stockholm, SE)</span>
              </a>
            </p>
          </div>

          <div className="date">may 6 |</div>
          <div className="item">
            <p>
              <span className="event">Årets instrument w/ Sören Hermansson (hn.)</span>
              <br />
              <span className="venue">Kungasalen, KMH (Stockholm, SE)</span>
            </p>
          </div>
        </div>

        <h3>2023</h3>

        <div className="container">
          <div className="date">nov 24 |</div>
          <div className="item">
            <p>
              <a
                href="https://www.instagram.com/p/Czj0gLhM8jj/?utm_source=ig_web_copy_link"
                target="_blank"
              >
                <span className="event">Amina Hocine &ndash; Jordprov release + friends</span>
                <br />
                <span className="venue">Lyssningsrum, Royal Institute of Art (Stockholm, SE)</span>
              </a>
            </p>
          </div>

          <div className="date">sep 16 |</div>
          <div className="item">
            <p>
              <a
                href="https://web.archive.org/web/20231019195614/https://www.envelopefestival.com/nordic-baltic-spatial-music-program"
                target="_blank"
              >
                <span className="event">Envelope Festival: Nordic Baltic Spatial Sound Works</span>
                <br />
                <span className="venue">Lyssningsrum, Royal Institute of Art (Stockholm, SE)</span>
              </a>
            </p>
          </div>

          <div className="date">may 29 |</div>
          <div className="item">
            <p>
              <a
                href="https://web.archive.org/web/20230530153714/https://www.tickster.com/sv/events/tbbblbpjnxjfdum/2023-05-29/tove-moller-wilma-hulten"
                target="_blank"
              >
                <span className="event">New music for more than two speakers</span>
                <br />
                <span className="venue">Lyssningsrum, Royal Institute of Art (Stockholm, SE)</span>
              </a>
            </p>
          </div>

          <div className="date">feb 23 |</div>
          <div className="item">
            <p>
              <a href="https://fylkingen.se/sv/events/jenny-berger-myhre-and-wilma-hulten#title" target="_blank">
                <span className="event">Solo set &ndash; live electronics</span>
                <br />
                <span className="venue">Fylkingen (Stockholm, SE)</span>
              </a>
            </p>
          </div>
        </div>

        <br />

        <h3>2022</h3>
        <div className="container">
          <div className="date">nov 9 |</div>
          <div className="item">
            <p>
              <a
                href="https://web.archive.org/web/20230106173655/https://kmh-evi.se/system/files/2022-11/Programblad%20Elektroakustiskt%20i%20november%202022.pdf?evitoken=65TPdza0FGAldbLZpe4h"
                target="_blank"
              >
                <span className="event">Elektroakustiskt i november</span>
                <br />
                <span className="venue">Lilla Salen, KMH (Stockholm, SE)</span>
              </a>
            </p>
          </div>

          <div className="date">aug 16 |</div>
          <div className="item">
            <p>
              <a
                href="https://ungnordiskmusik.is/artist/wilma_hulten"
                target="_blank"
              >
                <span className="event">Ung Nordisk Musik: Connecting Dots</span>
                <br />
                <span className="venue">Fríkirkjan (Reykjavík, IS)</span>
              </a>
            </p>
          </div>

          <div className="date">apr 15 |</div>
          <div className="item">
            <p>
              <a href="https://web.archive.org/web/20230106173650/https://fylkingen.se/node/2941" target="_blank">
                <span className="event">Solo set &ndash; live electronics</span>
                <br />
                <span className="venue">Fylkingen (Stockholm, SE)</span>
              </a>
            </p>
          </div>

          <div className="date">feb 4 |</div>
          <div className="item">
            <p>
              <a
                href="https://www.instagram.com/p/CZGzF2-MZTQ/?utm_source=ig_web_copy_link"
                target="_blank"
              >
                <span className="event">Blåsarsymfonikernas saxofonkvartett</span>
                <br />
                <span className="venue">Musikaliska (Stockholm, SE)</span>
              </a>
            </p>
          </div>
        </div>

        <br />

        <h3>2021</h3>

        <div className="container">
          <div className="date">dec 3 |</div>
          <div className="item">
            <p>
              <a
                href="https://web.archive.org/web/20230106173655/https://kmh-evi.se/system/files/2021-11/ljudOljud%20program%2C%2029%20nov-3%20dec%202021.pdf?evitoken=65TPdza0FGAldbLZpe4h"
                target="_blank"
              >
                <span className="event">ljudOljud: Elektroakustisk konsert II</span>
                <br />
                <span className="venue">Lilla Salen, KMH (Stockholm, SE)</span>
              </a>
            </p>
          </div>

          <div className="date">nov 12 |</div>
          <div className="item">
            <p>
              <a
                href="https://lillaakademien.se/konserter-events/2021/11/12/festivalen-framtidens-musik"
                target="_blank"
              >
                <span className="event">Stockholm Saxophone Quartet</span>
                <br />
                <span className="venue">Årsta Folkets Hus (Stockholm, SE)</span>
              </a>
            </p>
          </div>

          <div className="date">may 21 |</div>
          <div className="item">
            <p>
              <a
                href="https://www.youtube.com/watch?v=r90GS1Go1gc&list=WL&index=2&t=1268s&ab_channel=WilmaHult%C3%A9n?autoplay=1&mute=1"
                target="_blank"
              >
                <span className="event">Solo set &ndash; live electronics</span>
                <br />
                <span className="venue">Fylkingen (Stockholm, SE)</span>
              </a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Live;
